import { useState, useEffect } from 'react'

export default function useScaled({
	focus_width = 1,
	focus_height = null,
	root_ref
}) {
	const [[natural_width, natural_height], setNaturalSize] = useState([0, 0])
	const [scaled_size, set_scaled_size] = useState([0, 0, 0, 0]) // [w, h, top, left]

	useEffect(() => {
		if (!root_ref?.current || !natural_width || !natural_height) return

		const update_size = () => {
			const target_width = natural_width * focus_width
			const target_height = natural_height * (focus_height || 1)

			const scale_x = window.innerWidth / target_width

			let scale = scale_x

			if (focus_height !== null) {				
				const scale_y = window.innerHeight / target_height

				scale = Math.min(scale_x, scale_y)
			}

			const width = target_width * scale
			const height = target_height * scale

			const rect = root_ref.current.getBoundingClientRect()

			const offset_top = (rect.height - height) / 2
			const offset_left = (rect.width - width) / 2

			set_scaled_size([width, height, offset_top, offset_left])
		}

		const resize_observer = new ResizeObserver(update_size)
		resize_observer.observe(root_ref.current)

		update_size()

		return () => {
			resize_observer.disconnect()
			window.removeEventListener('resize', update_size)
		}
	}, [natural_width, natural_height, focus_width, focus_height])

	const memoSetNaturalSize = ([natural_width, natural_height]) => {
		setNaturalSize(prev => {
			if (prev[0] === natural_width && prev[1] === natural_height) return prev
			return [natural_width, natural_height]
		})
	}

	return [scaled_size, memoSetNaturalSize] // [scaled_width, scaled_height, top, left]
}